import { ComponentPropsWithRef, forwardRef } from "react";

type PaddingProps = ComponentPropsWithRef<"div"> & {
    padding?: number;
    paddingX?: number;
    paddingY?: number;
    paddingTop?: number;
    paddingBottom?: number;
    paddingLeft?: number;
    paddingRight?: number;
    style?: React.CSSProperties;
    boxSizing?: "content-box" | "border-box";
};

const Padding = forwardRef<HTMLDivElement, PaddingProps>(({
    children,
    padding = 16, paddingX, paddingY, 
    paddingTop, paddingBottom, paddingLeft, paddingRight,
    style, boxSizing = "content-box", ...props}, ref) => {
    const finalPaddingX = paddingX ?? padding;
    const finalPaddingY = paddingY ?? padding;
    const finalPaddingTop = paddingTop ?? finalPaddingY;
    const finalPaddingBottom = paddingBottom ?? finalPaddingY;
    const finalPaddingLeft = paddingLeft ?? finalPaddingX;
    const finalPaddingRight = paddingRight ?? finalPaddingX;
    return (
    <div
        ref={ref}
        style={{
            paddingTop: `${finalPaddingTop}px`,
            paddingBottom: `${finalPaddingBottom}px`,
            paddingLeft: `${finalPaddingLeft}px`,
            paddingRight: `${finalPaddingRight}px`,
            boxSizing: boxSizing,
            ...style
        }}
        {...props}
        >
            {children}
        </div>
    )
});

Padding.displayName = "Padding";

export default Padding;